export function schema_hit_parade(prevColumnNames) {
	return {
		title: "Paramètres",
		type: "object",
        required: ["column", "words", "remove_min"],
		properties: {
			column: {
				title: "Colonne",
				type: "string",
				options: {
					inputAttributes: {
						class: "form-control dropdown-colonne",
					},
				},
			},
			words: {
				type: "boolean",
				title: "Découper en mots",
				format: "checkbox",
			},
			remove_min: {
				type: "integer",
				title: "Minimum de lettres requis",
				default: 3,
			},
            min_nb: {
                type: "integer",
                title: "Nombre minimum de mots",
                default: 0,
            },
            max_nb: {
                type: "integer",
                title: "Nombre maximum de mots",
                default: 0,
            }
		},
	};
}
